export enum UploadStatus {
  Progress,
  Complete,
  Unhandled
}
